import React from 'react';

const SvgSk = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SK_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path
        d="M.949 1.335A1.398 1.398 0 0 1 2.335 0h5.996C9.07 0 9.69.596 9.718 1.335l.23 5.996c.029.738-.395 1.72-.96 2.204l-2.14 1.833c-.836.717-2.193.717-3.03 0L1.68 9.535C1.12 9.055.69 8.07.718 7.33l.23-5.996z"
        id="SK_svg__c"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SK_svg__b" fill="#fff">
        <use xlinkHref="#SK_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#0C47B7" mask="url(#SK_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#E53B35" mask="url(#SK_svg__b)" d="M0 13.333h28V20H0z" />
      <g mask="url(#SK_svg__b)">
        <g transform="translate(4.667 4)">
          <mask id="SK_svg__d" fill="#fff">
            <use xlinkHref="#SK_svg__c" />
          </mask>
          <path
            stroke="#FFF"
            strokeWidth={1.333}
            d="M.282 1.31A2.064 2.064 0 0 1 2.335-.667h5.996c1.097 0 2.011.88 2.053 1.977l.23 5.996c.037.943-.475 2.12-1.193 2.735l-2.139 1.833c-1.086.931-2.811.931-3.898 0l-2.139-1.833C.531 9.428.015 8.248.052 7.306l.23-5.996z"
          />
          <path
            d="M4.667 6.994a.335.335 0 0 0-.33-.327h-1.34a.328.328 0 0 1-.33-.337v-.66a.34.34 0 0 1 .33-.337h1.34c.182 0 .33-.142.33-.336v-.66A.331.331 0 0 0 4.33 4h-.66a.331.331 0 0 1-.337-.336v-.66c0-.187.143-.337.337-.337h.66a.331.331 0 0 0 .337-.337v-.66c0-.186.142-.337.336-.337h.66c.186 0 .337.143.337.337v.66c0 .186.143.337.336.337h.66c.187 0 .337.142.337.336v.66A.331.331 0 0 1 6.997 4h-.66A.331.331 0 0 0 6 4.336v.66a.34.34 0 0 0 .33.337h1.34c.182 0 .33.143.33.337v.66a.34.34 0 0 1-.33.337H6.33a.327.327 0 0 0-.33.327v2.012c0 .18-.143.327-.336.327h-.66a.33.33 0 0 1-.337-.327V6.994z"
            fill="#FFF"
            mask="url(#SK_svg__d)"
          />
          <path
            d="M4.13 9.425a1.333 1.333 0 0 1 2.407 0c1.62.256 2.796 1.013 2.796 1.908 0 1.105-1.79 2-4 2-2.209 0-4-.895-4-2 0-.895 1.176-1.652 2.797-1.908z"
            fill="#1251A1"
            mask="url(#SK_svg__d)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgSk;
